import Vue from 'vue'
import Router from 'vue-router'
import okcpRoutes from "@/router/routes/okcp";
import adminRoutes from "@/router/routes/admin";
import {adminChecker, contactChecker, roleChecker} from "@/router/checkers";
import organizationRoutes from "@/router/routes/organization";
import foundersRoutes from "@/router/routes/founder";
import expert from "@/router/routes/expert";

Vue.use(Router);

const NotFound = () => import('@/pages/404.vue');

const routes = new Router({
    mode: 'history',
    routes: [
        {
            path: process.env.IS_LOCAL === 'true' ? '/' : '',
            name: 'contacts',
            component: () => import("@/layouts/ContactLayout")
        },
        ...okcpRoutes,
        ...adminRoutes,
        ...foundersRoutes,
        ...organizationRoutes,
        ...expert,
        {
            path: '*',
            name: 'notfound',
            component: NotFound
        }
    ]
});

routes.beforeEach(async (to, from, next) => {
    await contactChecker(to, from, next);
    await roleChecker(to, from, next);
    await adminChecker(to, from, next);
});
export default routes;
